import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoofDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeRoofDoor"><Path d="M22.5469 9.37793L21.6729 10.5977L20 9.39941V21H14V14H10V21H4V9.39941L2.32715 10.5977L1.45312 9.37793L12 1.82715L22.5469 9.37793Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoofDoor;
